<template>
  <van-pagination
    class="pagination"
    v-model="tableInfo.page"
    :total-items="tableInfo.total"
    :page-count="totalPage"
    :show-page-size="tableInfo.showSize || 5"
    v-if="totalPage > 1"
    force-ellipses
    @change="changePage"
  >
    <template #prev-text>
      <van-icon name="arrow-left" class="arrow-left" />
    </template>
    <template #next-text>
      <van-icon name="arrow" />
    </template>
    <template #page="{ text }">{{ text }}</template>
  </van-pagination>
</template>

<script>
export default {
  props: {
    tableInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.tableInfo.total / this.tableInfo.pageSize);
    },
  },

  methods: {
    changePage(page) {
      this.$emit('changCurrentPage', page);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-pagination__item {
  color: #8c8c8c;
}
::v-deep .van-pagination__item--active {
  color: @primaryColor;
  background: #fffaed;
}
</style>
